
export class  formaPago {
    id: number;
    descripcion: string;
    idEmisor:number;
    codigoSri:string
    }

    